<template>
    <div class="scc-text-box" :class="[`scc-text-box--${backgroundColor}`]">
        <Heading class="scc-text-box__title" :color="`${backgroundColor}-contrast`" :tag="titleTag">{{
            title
        }}</Heading>
        <p class="scc-text-box__text" :class="title ? '' : 'no-title'">{{ text }}</p>
    </div>
</template>

<script>
import Heading from './Heading';
import './text-box.scss';
const values = ['primary', 'secondary', 'white', 'grey'];

export default {
    name: 'TextBox',
    components: { Heading },
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: values,
            },
        },
    },
    props: {
        titleTag: {
            type: String,
            default: 'h4',
            validator: function(val) {
                return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(val);
            },
        },
        title: {
            type: String,
            default: 'Titel van de textbox',
        },
        text: {
            type: String,
            default:
                'Dit is een voorbeeldtekst. <br> Deze kan aangepast worden om informatie te geven aan gebruikers over jouw winactie of loterij/',
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return values.includes(val);
            },
        },
    },
};
</script>
